var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('MediaItemCard',{attrs:{"title":_vm.title,"thumbnail":"mdi-folder","to":_vm.to,"thumbnail-icon":""},on:{"delete":_vm.onDelete}})
}
var staticRenderFns = []

export { render, staticRenderFns }